import { forwardRef } from 'react';

export const NotSureIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110" ref={ref} {...props}>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M94.4 33.3H15.5V97h78.9V33.3z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M94.4 19.1H15.5v14.2h78.9V19.1z"
        />
        <path
          fill="#FFF"
          d="M24.3 29.9c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5zm61.1 0c1.9 0 3.5-1.6 3.5-3.5s-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5 1.6 3.5 3.5 3.5z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M85.5 13.5v12.9M24.3 13.5v12.9"
        />
        <path
          fill="currentColor"
          d="M42.1 70.1c-.5 0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.5s.2-1 .6-1.4c.4-.4.9-.6 1.4-.6.5 0 1 .2 1.4.6.4.4.6.9.6 1.4 0 .4-.1.7-.3 1-.2.3-.4.6-.7.7-.2.3-.6.4-.9.4zm11.9 0c-.5 0-1.1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4 0-.6.2-1 .6-1.4.4-.4.9-.6 1.5-.6.5 0 1 .2 1.4.6.3.3.5.8.5 1.3 0 .4-.1.7-.3 1-.2.3-.4.6-.7.7-.3.3-.7.4-1 .4zm11.8 0c-.5 0-1.1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4 0-.6.2-1 .6-1.4.4-.4.9-.6 1.4-.6.5 0 1 .2 1.4.6s.6.9.6 1.4c0 .4-.1.7-.3 1-.2.3-.4.6-.7.7-.2.2-.6.3-1 .3z"
        />
      </svg>
    );
  },
);
